<template>
    <div class="row">
        <div class="col-lg-1"></div>
        <div class="col-lg-5">
            <div class="row">
                <div class="col-lg-6">
                    <div class="tile bg-primary" @click="navigate('/ugyfelek')">
                        <i class="fa fa-users fa-5x"></i>
                        <div class="tile-text">
                            Ügyfelek
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="tile bg-primary" @click="navigate('/uj-ugyfel')">
                        <i class="fa fa-user-plus fa-5x"></i>
                        <div class="tile-text">
                            Új ügyfél
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-5">
            <div class="row">
                <div class="col-lg-6">
                    <div class="tile bg-primary" @click="navigate('/szervizmunkak')">
                        <i class="fa fa-cogs fa-5x"></i>
                        <div class="tile-text">
                            Szervízmunkák
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="tile bg-primary" @click="navigate('/uj-szervizmunka')">
                        <i class="fa fa-wrench fa-5x"></i>
                        <div class="tile-text">
                            Új szervízmunka
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'Home',
        data(){
            return {

            }
        },
        methods: {
            navigate(destination){
                this.$router.push(destination);
            }
        }
    }
</script>

<style scoped>
    .tile{
        padding: 20px;
        text-align: center;
        color: #fff;
        margin-top: 20px;
        box-shadow: 2px 2px 5px 2px rgba(0,0,0,0.3);
        cursor: pointer;
    }

    .tile:hover{
        opacity: 0.9;
    }

    .tile-text{
        padding-top: 20px;
        font-size: 20px;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue